"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withoutPreHistory = withoutPreHistory;
/**
 * BEN-141 FP-131: a trend's months before the user's history began were drawn as
 * results. The discretionary series spans the whole scan window (13 months), so a
 * fresh connect's first nine months came back as $0: web's details table read
 * "$0.00, −$154.00 vs average" in green for each, and mobile drew nine stub bars.
 * They are not months of zero spending; there is no data for them.
 *
 * Drops the LEADING points that are incomplete (`complete === false`: before the
 * first transaction) AND empty. Everything else stays:
 * - a partial first month with real spend (drawn faint, as it is not in the basis);
 * - an interior $0 month, which is real data (BEN-141 D1);
 * - every point, when `complete` is absent (an older API trims nothing).
 */
function withoutPreHistory(points) {
    let start = 0;
    while (start < points.length &&
        points[start].complete === false &&
        points[start].amount === 0) {
        start += 1;
    }
    return points.slice(start);
}
//# sourceMappingURL=trendSeries.js.map